<template lang="pug">
.earn-page
  .earn-page__title(v-t="'earnWithVVV'")
  p.earn-page__p(v-t="'earnWithVVVText1'")

  .earn-page__choose-container
    .earn-page__variant-container(v-for="(variant, index) in variants" :key="variant.title")
      .earn-page__variant(:class="{'earn-page__variant--muted': index !== activeVariantIndex}" @click="setActiveVariantIndex(index)")
        .earn-page__variant-header
          img.earn-page__variant-image(:src="variant.labelImage")
          img.earn-page__variant-point(:src="`https://cdn.gaming-goods.com/images/other/info/choose-${Number(index === activeVariantIndex)}.png`")
          .earn-page__variant-title(v-t="variant.title")
        .earn-page__variant-description(v-t="variant.description")

  .earn-page__title(v-t="activeTab.title")

  NuxtLink(:to="localeLocation('/earn/verification')")
    .earn-page__banner-bloggers(v-show="activeVariantIndex === 0")
      .earn-page__banner-bloggers--left
        .earn-page__banner-bloggers-title(v-t="'bloggersBannerTitle'")
        .earn-page__banner-bloggers-text(v-t="'bloggersBannerText'")
      .earn-page__banner-bloggers--right
        Button.earn-page__banner-bloggers-button(is-primary) {{ $t('becomeAnInfluencer') }}

  .earn-page__cards
    .earn-page__card-container(v-for="card in cards[activeVariantIndex]" :key="card.title")
      .earn-page__card(:style="{backgroundImage: `url(${card.image})`}")
        .earn-page__card-title(v-t="card.title")
        button.earn-page__card-button.earn-page__card-button--grey(v-if="card.moreInfo" v-t="'moreInfo'" @click="openModal(card)")
        NuxtLink(v-else :to="localeLocation(card.link)")
          button.earn-page__card-button(v-t="card.buttonText")

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EarnPage',

  data () {
    return {
      variants: [
        {
          title: 'forBloggers',
          description: 'forBloggersDescription',
          labelImage:
            'https://cdn.gaming-goods.com/images/other/info/bloggers-text.png'
        },
        {
          title: 'forGamers',
          description: 'forGamersDescription',
          labelImage:
            'https://cdn.gaming-goods.com/images/other/info/gamers-text.png'
        }
      ],
      activeVariantIndex: 1,
      cards: [
        [
          {
            title: 'earnOnReferrals',
            buttonText: 'earnOnReferralsButton',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20earn%20money%20on%20referrals.png',
            moreInfo: false,
            comingSoon: false,
            link: '/earn/referral'
          },
          {
            title: 'playFreeOrCommunityTournaments',
            buttonText: 'playFreeOrCommunityTournamentsButton',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20play%20free%20or%20community%20tournaments.png',
            moreInfo: false,
            comingSoon: false,
            link: '/tournaments'
          },
          {
            title: 'playWithFans',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20make%20predictions.png',
            moreInfo: true,
            comingSoon: true,
            description: 'playWithFansDescription'
          },
          {
            title: 'askForPredictions',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20make%20predictions.png',
            moreInfo: true,
            comingSoon: true,
            description: 'askForPredictionsDescription'
          },
          {
            title: 'createYourOwnChallenges',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20make%20predictions.png',
            moreInfo: true,
            comingSoon: true,
            description: 'createYourOwnChallengesDescription'
          }
        ],
        [
          {
            title: 'earnOnReferrals',
            buttonText: 'earnOnReferralsButton',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20earn%20money%20on%20referrals.png',
            moreInfo: false,
            comingSoon: false,
            link: '/earn/referral'
          },
          {
            title: 'playFreeOrCommunityTournaments',
            buttonText: 'playFreeOrCommunityTournamentsButton',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20play%20free%20or%20community%20tournaments.png',
            moreInfo: false,
            comingSoon: false,
            link: '/tournaments'
          },
          {
            title: 'earnMoneyAndTicketsInMissions',
            buttonText: 'earnMoneyAndTicketsInMissionsButton',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20earn%20money%20and%20tickets%20in%20missions.png',
            moreInfo: false,
            comingSoon: false,
            link: '/missions'
          },
          {
            title: 'createYourOwnTournaments',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20make%20predictions.png',
            moreInfo: true,
            comingSoon: true,
            description: 'createYourOwnTournamentsDescription'
          },
          {
            title: 'makePredictions',
            image:
              'https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20make%20predictions.png',
            moreInfo: true,
            comingSoon: true,
            description: 'makePredictionsDescription'
          }
        ]
      ]
    }
  },

  computed: {
    activeTab () {
      return this.variants[this.activeVariantIndex]
    }
  },

  methods: {
    ...mapActions('modal', ['showModal', 'toggle']),

    setActiveVariantIndex (index) {
      this.activeVariantIndex = index
    },

    openModal (card) {
      this.showModal({
        component: 'ModalMessage',
        data: {
          title: this.$t(card.title),
          type: 'plain',
          text: this.$t(card.description),
          buttons: [
            {
              props: { isPrimary: true },
              title: this.$t('iWantToSoon'),
              shouldClose: true
            }
          ]
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.earn-page {
  padding: 32px 16px;

  @media (min-width: $breakpointTablet) {
    padding: 33px 24px;
  }

  @media (min-width: $breakpointDesktop) {
    padding: 57px 106px;
  }

  &__banner-bloggers {
    background-color: $primary90;
    margin-bottom: 48px;
    padding: 24px 32px;
    border-radius: 12px;

    // background-image: url('https://cdn.gaming-goods.com/images/Earn%20with%20vvvgamers/for%20gamers/x1%20make%20predictions.png');
    background-repeat: no-repeat;
    background-position: right top;
    cursor: pointer;

    @media (min-width: $breakpointTablet) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-button {
      margin-top: 24px;
      margin-bottom: 24px;

      @media (min-width: $breakpointTablet) {
        margin: 0;
      }
    }

    &-title {
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 28px;
      color: $white;
      max-width: 420px;
      margin-top: 40px;

      @media (min-width: $breakpointTablet) {
        margin-top: 0;
      }

      @media (min-width: $breakpointDesktop) {
        font-size: 22px;
        line-height: 30px;
        max-width: 100%;
      }
    }

    &-text {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: $white;
      max-width: 420px;
      margin-top: 12px;

      @media (min-width: $breakpointDesktop) {
        max-width: 100%;
      }
    }
  }

  &__title {
    margin-bottom: 24px;
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    color: $white;

    @media (min-width: $breakpointDesktop) {
      font-size: 48px;
      line-height: 58px;
    }
  }

  &__p {
    max-width: 780px;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 24px;
    color: $blue-grey05;

    @media (min-width: $breakpointDesktop) {
      font-size: 18px;
      line-height: 28px;
    }
  }

  &__choose-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 6px;
    margin-top: 33px;
    margin-bottom: 84px;

    @media (min-width: $breakpointTablet) {
      grid-gap: 16px;
      margin-top: 32px;
      margin-bottom: 76px;
    }

    @media (min-width: $breakpointDesktop) {
      margin-top: 48px;
    }
  }

  &__variant {
    min-height: 194px;
    padding: 8px;
    background-color: $blue-grey70;
    border: 2px solid $primary60;
    border-radius: 12px;
    cursor: pointer;

    @media (min-width: $breakpointTablet) {
      padding: 20px;
    }

    &--muted {
      opacity: 0.3;
      border: none;
    }

    &-header {
      display: grid;
      grid-template-columns: max-content 1fr;
      grid-column-gap: 14px;
      align-items: center;
      margin-bottom: 10px;

      @media (min-width: $breakpointTablet) {
        align-items: start;
        grid-column-gap: 24px;
      }

      @media (min-width: $breakpointDesktop) {
        grid-template-columns: 1fr max-content;
      }
    }

    &-image {
      width: 100%;
      grid-column: 1 / 3;
      height: 56px;
      object-fit: cover;
      object-position: 50% 0;

      @media (min-width: $breakpointTablet) {
        grid-column: 2 / 3;
        object-position: 50% 25%;
      }

      @media (min-width: $breakpointDesktop) {
        width: 250px;
      }
    }

    &-point {
      @media (min-width: $breakpointTablet) {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
      }
    }

    &-title {
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      color: $white;

      @media (min-width: $breakpointTablet) {
        grid-column: 1 / 3;
        font-size: 24px;
        line-height: 32px;
      }
    }

    &-description {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: $blue-grey10;

      @media (min-width: $breakpointTablet) {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  &__cards {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 24px;
    padding-bottom: 20px;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: $breakpointDesktop) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  &__card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: top right;

    &-container {
      background-color: $blue-grey70;
      border-radius: 12px;
    }

    &-title {
      margin: 20px;
      max-width: 212px;
      color: rgba($white, 0.9);
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
    }

    &-button {
      margin: 20px 20px 20px 24px;
      padding: 0 24px;
      height: 48px;
      border-radius: 8px;
      border: 2px solid $primary60;
      color: $primary60;
      background: transparent;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      cursor: pointer;

      &--grey {
        border: 2px solid $blue-grey10;
        color: $blue-grey10;
      }
    }
  }
}
</style>
